import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityHoliday } from "../../entity/EntityHoliday";

export class DtoHolidaysGetRes extends EntityHoliday {
  public items: EntityHoliday[]  = [];
}
